import React from 'react';
import { I18n } from 'Locales';
import PropTypes from 'prop-types';
import { Preloader } from 'framework7-react';

import { f7Colors } from 'Theme';
import { ColumnView } from 'Containers';

const SplashScreen = ({ orientation }) => (
  <ColumnView height={'100%'} backgroundColor="#282626">
    <img
      src={'/static/images/field-iq-logo.png'}
      alt="Field IQ Logo"
      style={{
        maxHeight: '60px',
        width: 'auto',
        paddingRight: '24px'
      }}
    />
    {orientation === 'portrait' && <Preloader size={20} color={f7Colors.multi} />}
    {orientation === 'landscape' && `${I18n.t('general:portraitOnly')}`}
  </ColumnView>
);

SplashScreen.propTypes = {
  orientation: PropTypes.string
};

export default SplashScreen;
